/** Русское склонение: plural(2, ['день', 'дня', 'дней']) → 'дня'. */
export function plural(n, forms) {
  const abs = Math.abs(Number(n) || 0) % 100;
  if (abs > 10 && abs < 20) return forms[2];
  const last = abs % 10;
  if (last === 1) return forms[0];
  if (last >= 2 && last <= 4) return forms[1];
  return forms[2];
}

/** «12 дней» — число и слово в нужной форме. */
export const pluralize = (n, forms) => `${formatNumber(n)} ${plural(n, forms)}`;

/** 1596 → «1 596» (неразрывный узкий пробел не нужен — обычный читается лучше в Inter). */
export function formatNumber(n) {
  const v = Number(n) || 0;
  return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export const FORMS = {
  days: ['день', 'дня', 'дней'],
  words: ['слово', 'слова', 'слов'],
  phrases: ['фраза', 'фразы', 'фраз'],
  cards: ['карточка', 'карточки', 'карточек'],
  minutes: ['минута', 'минуты', 'минут'],
  records: ['запись', 'записи', 'записей'],
  sets: ['набор', 'набора', 'наборов'],
  achievements: ['достижение', 'достижения', 'достижений'],
  lessons: ['урок', 'урока', 'уроков'],
  friends: ['друг', 'друга', 'друзей']
};
